import { EventSourcePolyfill } from 'event-source-polyfill';
import { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateCurrentDownloadingNotification,
  addNotification,
  setNewVersion,
} from 'store';
import { getEnv } from 'utils';

const useNotifications = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.accountReducer.currentUser);

  const sourceRef = useRef(null);
  const noNotification = window.location.pathname.match(
    /\/login|\/change-password|\/home/g
  );

  /**
   * اجرای سوکت
   */
  const init = () => {
    sourceRef.current = new EventSourcePolyfill(
      `${getEnv('REACT_APP_BASE_API')}/chapaar/api/notification/sse`,
      {
        headers: {
          Authorization: currentUser?.access_token,
        },
      }
    );

    sourceRef.current.onmessage = (event) => {
      if (event.data === 'keep-alive') {
        return;
      }

      const notification = JSON.parse(event.data);
      if (notification.type === 'topic_modeling') {
        return;
      }
      if (
        notification.type === 'password_expired_notification' ||
        notification.type === 'notify-all'
      ) {
        dispatch(addNotification({ notification: notification }));
      } else if (
        notification.type === 'search_excel' ||
        notification.type === 'bulletin_export_pdf' ||
        notification.type === 'bulletin_export_docx'
      ) {
        dispatch(
          updateCurrentDownloadingNotification({
            updatedNotification: notification,
          })
        );
      } else if (notification.type === 'version_published') {
        dispatch(setNewVersion({ newVersion: notification.data.version_name }));
      }
    };
  };

  useEffect(() => {
    if (noNotification) return;
    if (!sourceRef.current && currentUser?.user?.id) {
      init();
    }

    // return () => {
    //   sourceRef.current?.close();
    // };
  }, [currentUser, noNotification]);
};

export default useNotifications;
